import { call, put, take, takeEvery } from "redux-saga/effects";

// Category Redux States
import {
    GET_ALL_MUSEUMS,
    GET_ALL_MUSEUMS_SUCCESS,
    GET_ALL_MUSEUMS_FAIL,
    GET_MUSEUM_SUCCESS,
    GET_MUSEUM_FAIL,
    GET_MUSEUM,
    GET_TOP_MUSEUM,
    GET_TOP_ARTISTS,
    GET_ALL_ARTISTS
} from "./actionTypes";
import { getALLMuseumsFail, getALLMuseumsSuccess, getTopAtistFail, getTopMuseumFail, getTopMuseumSuccess, getTopArtistSuccess, getAllArtistSuccess, getAllAtistFail} from "./actions";
import { getAllMuseumsApi, getTopMuseumApi,getTopArtistApi, getAllArtistApi } from "helpers/backend_helper";

function* fetchMuseums() {
  try {
    const response = yield call(getAllMuseumsApi);
    if (response.status === "failure") {
      return yield put(getALLMuseumsFail(response.message));
    }
    // callback && callback(response);
    yield put(getALLMuseumsSuccess(response.data));
  } catch (error) {
    yield put(getALLMuseumsFail(error));
  }
}
function* fetchTopMuseums() {
  try {
    const response = yield call(getTopMuseumApi);
    if (response.status === "failure") {
      return yield put(getTopMuseumFail(response.message));
    }
    // callback && callback(response);
    yield put(getTopMuseumSuccess(response.data));
  } catch (error) {
    yield put(getTopMuseumFail(error));
  }
}

function* fetchTopArtist() {
  try {
    const response = yield call(getTopArtistApi);
  
    if (response.status === "failure") {
      return yield put(getTopAtistFail(response.message));
    }
    // callback && callback(response);
    yield put(getTopArtistSuccess(response.data));
  } catch (error) {
    yield put(getTopAtistFail(error));
  }
}


function* fetchAllArtist( {payload : {data, callback}} ) {
  try {
    const response = yield call(getAllArtistApi, data);
    if (response.status === "failure") {
      return yield put(getAllAtistFail(response.message));
    }
    callback && callback(response);
    yield put(getAllArtistSuccess(response));
  } catch (error) {
    yield put(getAllAtistFail(error));
  }
}

function* CategoriesSaga() {
  yield takeEvery(GET_ALL_MUSEUMS, fetchMuseums);
  yield takeEvery(GET_TOP_MUSEUM, fetchTopMuseums);
  yield takeEvery(GET_TOP_ARTISTS, fetchTopArtist);
  yield takeEvery(GET_ALL_ARTISTS, fetchAllArtist);
  
//   yield takeEvery(CATEGORIES, onGetNewCategories);
//   yield takeEvery(GET_SUBCATEGORIES, onGetSubCategories);
}

export default CategoriesSaga;
